import { ref } from 'vue'
import { FragmentType, useFragment } from '@/gql'
import { ComplianceAlertFragmentDoc } from '@/gql/graphql'

export const filterActive = ref(true)

export default (compliances: FragmentType<typeof ComplianceAlertFragmentDoc>[]) => {
  const mapped = compliances.map((comp) => useFragment(ComplianceAlertFragmentDoc, comp))

  return mapped.filter((comp) => comp.applicable || !filterActive.value)
}
